.mobileFilterRow {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  margin-left: 16px;
}

.mobileActionSlot {
  display: contents;
}

@media all and (--reefer-media-tablet-min) {
  .mobileFilterRow {
    display: none;
  }

  .mobileActionSlot {
    display: none;
  }
}
